function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Validator = /*#__PURE__*/function () {
  /**
   * @param {function|null} message
   * @param {function|null} test
   */
  function Validator() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Validator);

    this.message = message === null ? this.constructor.message : message;
    if (typeof test === "function") this.test = test;
    this.args = {};
    this.continueOnError = true;
    this.id = this.constructor.name;
  }
  /**
   * @param {function|string} message
   * @returns {Validator}
   */


  _createClass(Validator, [{
    key: "setMessage",
    value: function setMessage(message) {
      this.message = message;
      return this;
    }
    /**
     * @returns {Validator}
     */

  }, {
    key: "break",
    value: function _break() {
      this.continueOnError = false;
      return this;
    }
    /**
     * @param id
     * @returns {Validator}
     */

  }, {
    key: "identify",
    value: function identify(id) {
      this.id = id;
      return this;
    }
    /**
     * @param value
     * @param  {Validation} validation
     */

  }, {
    key: "test",
    value: function test(value, validation) {
      return true;
    }
    /**
     * @param {Validation} validation
     */

  }, {
    key: "validate",
    value: function validate(validation) {
      return this.test(validation.value, validation);
    }
  }]);

  return Validator;
}();

_defineProperty(Validator, "message", function () {
  return 'Validation error';
});

export { Validator as default };